const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Tracks Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Journeys', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/learn/v3/journeys/:subresource/:action', null, {
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    update: {params: {subresource: ''}, method: 'PATCH', isArray: false},
    archive: {params: {subresource: '', action: 'archive'}, method: 'PATCH', isArray: false},
  });

}]);
